import React from "react";
import { useNavigate } from "react-router-dom";
import AuthFormCard from "components/auth-form-card/AuthFormCard";
import AuthForm from "components/auth-form/AuthForm";
import LoadingModalV1 from "modals/loading/LoadingModalV1";
import ErrorModal from "modals/error-modal/ErrorModal";
import { useLoginForm } from "./useLoginForm";

/**
 * Login form — composes the shared card shell, the reusable field form,
 * and the two feedback modals. All state lives in useLoginForm.
 */
function LoginForm() {
  const navigate = useNavigate();
  const {
    fields,
    submitRef,
    isSubmitDisabled,
    showLoading,
    loadingMsg,
    showError,
    errorMsg,
    handleLogin,
    handleCloseError,
  } = useLoginForm();

  return (
    <>
      <AuthFormCard
        title="Welcome back"
        subtitle="Sign in to your Kea Valley account"
      >
        <AuthForm
          fields={fields}
          submitLabel="Sign in"
          onSubmit={handleLogin}
          disabled={isSubmitDisabled}
          isLoading={showLoading}
          submitRef={submitRef}
        />

        <p className="v1-auth-nav">
          <button
            className="v1-auth-nav-link"
            type="button"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot password?
          </button>
        </p>

        {/* <p className="v1-auth-nav">
          Don&apos;t have an account?{" "}
          <button
            className="v1-auth-nav-link"
            onClick={() => navigate("/signup")}
            type="button"
          >
            Sign up
          </button>
        </p> */}
      </AuthFormCard>

      <LoadingModalV1 isOpen={showLoading} loadingMsg={loadingMsg} />

      <ErrorModal
        isOpen={showError}
        errorMsg={errorMsg}
        handleClose={handleCloseError}
        tryAgain={handleCloseError}
      />
    </>
  );
}

export default LoginForm;
